import { Component } from '@angular/core';

@Component({
  selector: 'app-account-left-banner',
  standalone: true,
  imports: [],
  templateUrl: './account-left-banner.component.html',
  styleUrl: './account-left-banner.component.css'
})
export class AccountLeftBannerComponent {

}
